import Model from './Model';

import GetSeoTagResponse from 'Api/CRM/Responses/SeoTagResponse';

export default class SeoTag extends Model {
    readonly route: string | null;
    readonly title: string | null;
    readonly meta_description: string | null;
    readonly meta_keywords: string | null;
    readonly og_description: string | null;
    readonly og_image: string | null;
    readonly og_url: string | null;
    readonly og_type: string | null;

    constructor(seoTag: Partial<GetSeoTagResponse>) {
        super();
        this.assignDataToProps(seoTag, [
            'route',
            'title',
            'meta_description',
            'meta_keywords',
            'og_description',
            'og_image',
            'og_url',
            'og_type',
        ]);
    }
}
